import { useEffect, useState } from "react";
import { _EmployeeIncapacity, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_BOOLEAN_ICON, MASK_DATE, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { AccountEditor } from "../../../editor/AccountEditor";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { InputDate } from "../../../theme/Input/InputDate";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { IncapacityTypeConstantsEditor } from "./IncapacityEditors/IncapacityTypeConstants.editor";
import { LiquidateMonthConstantsEditor } from "./IncapacityEditors/LiquidateMonthConstantsEditor";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AppliedIncapacity } from "./AppliedIncapacity/AppliedIncapacity";
import { _IncapacityStates, _Updatedistribution, _Updateemployee } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { PayrollMonthsConstantsEditor } from "../../ParametrosTalentoHumano/EmployeeBonus/Editors/PayrollMonthsConstants.editor";
import { AccountantYear } from "../EmployeeContract/ProductionPlan/AccountantYear";
import usePaginator from "../../../theme/Component/usePaginator";
import { IncapacityStateConstants } from "./IncapacityEditors/IncapacityStateConstants/IncapacityStateConstants";
import { FileService } from "../../../../core/services/FileService";
import { FileInput } from "../../../theme/Component/FileInput";
import useModal, { MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { ExportXLSL } from "../../../theme/Component/ExportXLSX";
import { DropDown } from "../../../theme/Component/DropDown";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { SelectElectronicPayrollIncapacitiesYears } from "./IncapacityEditors/SelectElectronicPayrollIncapacitiesYears";
import { SelectElectronicPayrollIncapacitiesMonths } from "./IncapacityEditors/SelectElectronicPayrollIncapacitiesMonths";


type permisions = {
    canEdit?: boolean;
    canDelete?: boolean;
    canCreate?: boolean;
    canRadicar?: boolean;
}

type componentProps = {
    permisions?: permisions;
    autoGestion?: boolean;
}

const DEFAULT_COMPONENT_PROPS = { autoGestion: false } as const;

interface EmployeeIncapacityComponentProps {
    isModal?: boolean;
    componentProps?: componentProps;
}

type formFilter = {
    IDAccount: number;
    Year: number;
    Month: number;
    State: number;
    Type: number;
}

type customForm = {
    InitialPaymentMonth: number;
    Year: number;
    Month: number;
    FiledNumber: number;
    Observations: string;
}

export const EmployeeIncapacity = ({ componentProps = DEFAULT_COMPONENT_PROPS, isModal }: EmployeeIncapacityComponentProps) => {

    const { instance, lista, setLista, bean, setBean, handleChange } = useDataBean(_EmployeeIncapacity);
    const fileService = new FileService();

    const paginador = usePaginator();

    const [listaAll, setListaAll] = useState<any>([]);
    const [missingFields, setMissingFields] = useState<string[]>([]);
    const [formData, setFormData] = useState<Partial<formFilter>>({
        Year: _single.getCurrenYear(),
        IDAccount: componentProps.autoGestion ? _single.getAccountID() : null,
    })
    const [customForm, setCustomForm] = useState<Partial<customForm>>({});

    const [modalaplicar, setModalaplicar] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalradicar, setModalradicar] = useState<any>({ name: 'Radicar Incapacidad', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalrechazar, setModalrechazar] = useState<any>({ name: 'Rechazar Incapacidad', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalconsultar, setModalconsultar] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalgenerar, setModalgenerar] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalDownload = useModal("Consolidado", MODAL_SM);

    useEffect(() => {
        getLista()
    }, [paginador.page]);



    const getLista = () => {
        instance.getEmployeeIncapacitiesforpaginator(formData.IDAccount, formData.Year, formData.Month, formData.State, formData.Type, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)

                    let item = resp.List;
                    item.forEach((e: any) => {
                        if (e.DataBeanProperties.MediaContext) {
                            e.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(e.DataBeanProperties.MediaContext, e.DataBeanProperties.Media)}" target='_blank'>DESCARGAR DOCUMENTO</a>`
                        } else {
                            e.DataBeanProperties.URL = "Sin Documento";
                        }
                        const fromDate = e.DataBeanProperties.FromDate ? new Date(e.DataBeanProperties.FromDate) : null;
                        const uptoDate = e.DataBeanProperties.UptoDate ? new Date(e.DataBeanProperties.UptoDate) : null;


                        if (fromDate && uptoDate) {
                            const diffTime = Math.abs(uptoDate.getTime() - fromDate.getTime());
                            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
                            e.DataBeanProperties.FechaTotalDays = diffDays + 1;
                        } else {

                            e.DataBeanProperties.FechaTotalDays = 0;
                        }
                    });
                    setLista(item);
                }
            }
        )
    }

    const getListaAll = () => {
        instance.getEmployeeIncapacitiesforpaginator(formData.IDAccount, formData.Year, formData.Month, formData.State, formData.Type, 1, 15 * paginador.pages).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)

                    let item = resp.List;
                    item.forEach((e: any) => {
                        if (e.DataBeanProperties.MediaContext) {
                            e.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(e.DataBeanProperties.MediaContext, e.DataBeanProperties.Media)}" target='_blank'>DESCARGAR DOCUMENTO</a>`
                        } else {
                            e.DataBeanProperties.URL = "Sin Documento";
                        }
                        const fromDate = e.DataBeanProperties.FromDate ? new Date(e.DataBeanProperties.FromDate) : null;
                        const uptoDate = e.DataBeanProperties.UptoDate ? new Date(e.DataBeanProperties.UptoDate) : null;


                        if (fromDate && uptoDate) {
                            const diffTime = Math.abs(uptoDate.getTime() - fromDate.getTime());
                            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
                            e.DataBeanProperties.FechaTotalDays = diffDays + 1;
                        } else {

                            e.DataBeanProperties.FechaTotalDays = 0;
                        }
                    });

                    //console.log("Lista con días calculados:", List);

                    setListaAll(item);
                }
            }
        )
    }

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
            IDAccount: componentProps.autoGestion ? _single.getAccountID() : null,
            Since: _single.getCurrenDate(),
            LiquidateToTotalSalary: false,
            ApplyIBC: false,
            ApplyPaymentDistribution: false,
            Extending: false,
            Hospitalization: false,
            Days_90: false,
            Days_180: false,
        });
        setModal({ ...modal, "view": true, name: "Agregar Incapacidad" });
    }

    const deleteItem = () => {
        instance.deleteEmployeeIncapacity(bean.IDIncapacity).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        });
    }

    const editaItem = () => {
        const x = { ...bean, IDEmployee: _single.getAccountID() };
        instance.updateEmployeeIncapacity(x).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        });
    }

    const updateMonthAppliedIncapacityDistribution = () => {
        if (!customForm.Year) {
            toast.warning("Debe seleccionar un Año.");
            return;
        }
        if (!customForm.InitialPaymentMonth) {
            toast.warning("Debe seleccionar un Mes inicial de pago.");
            return;
        }
        instance.updateMonthAppliedIncapacityDistribution(bean.IDIncapacity, customForm.Year, customForm.InitialPaymentMonth).then(
            (resp: any) => {

                setCustomForm({});
                setModalgenerar({ ...modalgenerar, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        });
    }

    const updatetEmployeeIncapacitiesDistribution = () => {
        if (!customForm.Year) {
            toast.warning("Debe seleccionar un Año.");
            return;
        }

        instance.updatetEmployeeIncapacitiesDistribution(null, customForm.Year, customForm.Month).then(
            (resp: any) => {

                setCustomForm({});
                setModalaplicar({ ...modalaplicar, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        });
    }

    const fileEmployeeIncapacity = () => {
        instance.fileEmployeeIncapacity(bean.IDIncapacity, customForm.FiledNumber, _single.getAccountID()).then(
            (resp: any) => {
                getLista();
                toast.success('Incapacidad radicada');
                setModalradicar({ ...modalradicar, "view": false });
                setCustomForm({});
            }
        ).catch(err => {
            toast.error(err);
        });
    }

    const approveEmployeeIncapacity = () => {
        instance.approveEmployeeIncapacity(bean.IDIncapacity, _single.getAccountID()).then(
            (resp: any) => {
                getLista();
                toast.success('Incapacidad Aprobada');
                setCustomForm({});
            }
        ).catch(err => {
            toast.error(err);
        });
    }

    const rejectEmployeeIncapacity = () => {
        instance.rejectEmployeeIncapacity(bean.IDIncapacity, customForm.Observations, _single.getAccountID()).then(
            (resp: any) => {
                getLista();
                toast.success('Incapacidad Rechazada');
                setModalrechazar({ ...modalrechazar, "view": false });
                setCustomForm({});
            }
        ).catch(err => {
            toast.error(err);
        });
    }

    const head = [
        { title: 'ID', property: 'IDIncapacity', visible: true, mask: MASK_NUMBER },
        { title: 'Empleado', property: 'AccountName', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Inicio en', property: 'FromDate', visible: true, mask: MASK_DATE },
        { title: 'Terminación en', property: 'UptoDate', visible: true, mask: MASK_DATE },
        { title: 'Año a aplicar', property: 'Year', visible: true, mask: MASK_NUMBER },
        { title: 'Mes a aplicar', property: 'MonthName', visible: true },
        { title: 'A Cargo de', property: 'Third', visible: true },
        { title: 'Diagnóstico', property: 'Description', visible: true, },
        { title: 'Prorroga', property: 'Extending', visible: true },
        { title: 'Hospitalización', property: 'Hospitalization', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Soporte de la Incapacidad', property: 'URL', visible: true },
        { title: 'Numero de Radicación', property: 'FileNumber', visible: true },
        { title: 'Fecha de Radicación', property: 'FiledDate', visible: true },
        { title: 'Usuario que Radica', property: 'FiledAccountName', visible: true },
        { title: 'Usuario que Rechaza', property: 'RejectedAccountName', visible: true },
        { title: 'Fecha Rechazo', property: 'RejectedDate', visible: true },
        { title: 'Observaciones de Rechazo', property: 'RejectedObservations', visible: true },
        { title: 'Prórroga', property: 'Extending', visible: true },
        { title: '+90 Días', property: 'Days_90', visible: true },
        { title: '+180 Días', property: 'Days_180', visible: true },
        { title: 'Fecha de Creación', property: 'Since', visible: true },
        { title: 'Duración Incapacidad', property: 'FechaTotalDays', visible: true },
        { title: 'Definir IBC', property: 'ApplyIBC', visible: true },
        { title: 'IBC', property: 'Ibc', visible: true },
        { title: 'Aplicar Distribución de Pagos', property: 'ApplyPaymentDistribution', visible: true },
        { title: 'IBC a Aplicar', property: 'ApplyIBC', visible: true },
        { title: 'Funcionario', property: 'EmployeeName', visible: true },
        { title: 'Liquidar al 100% del Salario', property: 'LiquidateToTotalSalary', visible: true },
    ]

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem();
        }
    }

    const veraplicar = () => {
        setModalaplicar({ ...modalaplicar, "view": true });
    }

    const validateForm = () => {
        const requiredFields = [
            "Month", "IDAccount", "Year", "Type", "FromDate", "UptoDate", "Description"
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }

        setMissingFields(missing);
        console.log(missing)
        return missing.length
    };

    const resolvePermission = (
        propPermission: boolean | undefined,
        fallback: () => boolean
    ) => {
        if (componentProps?.autoGestion) {
            return propPermission ?? false;
        }
        return fallback();
    };


    const listaBotones = () => {
        const botones = [
            {
                titulo: 'Editar Incapacidad',
                icono: 'ri-edit-2-line',
                visible: resolvePermission(
                    componentProps?.permisions?.canEdit,
                    () => _single.canEdit()
                ),
                evento: () => {
                    setModal({ ...modal, name: "Editar Incapacidad Laboral", view: true });
                    setBean({
                        ...bean,
                        IDEmployee: _single.getAccountID(),
                    });
                },
            },

            {
                titulo: 'Consultar Distribución de Pagos de Incapacidad',
                icono: 'ri-contacts-book-line',
                visible: componentProps.autoGestion ? false : _single.canEdit(),
                evento: () => setModalconsultar({ ...modalconsultar, view: true, name: "Distribución de Pagos de Incapacidad" }),
            },

            {
                titulo: 'Generar Distribución para Pagos',
                icono: 'ri-money-dollar-circle-line',
                visible: componentProps.autoGestion ? false : _single.canEdit() && bean.State == 4,
                evento: () => {
                    setModalgenerar({ ...modalgenerar, view: true })
                },
            },

            {
                titulo: 'Radicar Incapacidad',
                icono: 'ri-mail-send-line',
                visible: resolvePermission(
                    componentProps?.permisions?.canRadicar,
                    () => _single.canEdit()
                ) && bean.State == 2,
                evento: () => setModalradicar({ ...modalradicar, view: true }),
            },

            {
                titulo: 'Aprobar Incapacidad',
                icono: 'ri-chat-check-line',
                visible: componentProps.autoGestion ? false : _single.canEdit(),
                evento: approveEmployeeIncapacity,
            },

            {
                titulo: 'Rechazar Incapacidad',
                icono: 'ri-chat-delete-line',
                visible: componentProps.autoGestion ? false : _single.canEdit(),
                evento: () => setModalrechazar({ ...modalrechazar, view: true }),
            },

            {
                titulo: 'Eliminar Incapacidad',
                icono: 'ri-delete-bin-line',
                visible: resolvePermission(
                    componentProps?.permisions?.canDelete,
                    () => _single.canDelete()
                ),
                evento: () => setModalC({ ...modalC, view: true }),
            },
        ];

        return <ListMenu listaBotones={botones} />;
    };


    const iconButtonsItem = [
        {
            nombre: 'Agregar', visible: resolvePermission(
                componentProps?.permisions?.canCreate,
                () => _single.canCreate()
            ), icono: 'ri-file-add-line', evento: create
        }
    ]

    const actionsDropDown = [
        { id: 1, name: 'Descargar Reporte', permiso: null, activo: true },

    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id === 1) {
                            getListaAll();
                            modalDownload.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }

    const commonFieds = (
        <>
            <div className="col-md-6">
                <label className={`${missingFields.includes('FromDate') ? 'has-error' : ''}`}>Inicio en</label>
                <InputDate label=" " name="FromDate" value={bean.FromDate} setDate={(e: any) => { setBean({ ...bean, 'FromDate': e }) }} />
            </div>

            <div className="col-md-6">
                <label className={`${missingFields.includes('UptoDate') ? 'has-error' : ''}`}>Terminación en</label>
                <InputDate label=" " name="UptoDate" value={bean.UptoDate} setDate={(e: any) => { setBean({ ...bean, 'UptoDate': e }) }} />
            </div>

            <div className="col-md-6">
                <FileInput Media={bean.Media} MediaContext={bean.MediaContext} label="Soporte de la Incapacidad" directory="incapacity"
                    onCreate={(e: any) => setBean({ ...bean, 'Media': e.Media, 'MediaContext': e.MediaContext })}
                />
            </div>

            <div className="col-md-6">
                <label className={`${missingFields.includes('Type') ? 'has-error' : ''}`}>Tipo de Incapacidad</label>
                <IncapacityTypeConstantsEditor idSelector={bean.Type} onChange={(e) => { setBean({ ...bean, "Type": e }) }} label=" " />
            </div>

            <div className="col-md-6">
                <label className={`${missingFields.includes('Year') ? 'has-error' : ''}`} >Año a Aplicar</label>
                {/* <YearSelector value={bean.Year} currentTerm tittle=" " onChange={(e) => { setBean({ ...bean, Year: e }) }} /> */}
                <SelectElectronicPayrollIncapacitiesYears idSelector={bean.Year} onChange={(e) => { setBean({ ...bean, Year: e }) }} label=" " />
            </div>

            <div className="col-md-6">
                <label className={`${missingFields.includes('Month') ? 'has-error' : ''}`} >Mes a Aplicar</label>
                <SelectElectronicPayrollIncapacitiesMonths year={bean.Year} label=" " idSelector={bean.Month} onChange={(e) => { setBean({ ...bean, "Month": e }) }} />
            </div>

            <div className="col-md-12">
                <label className={`${missingFields.includes('Description') ? 'has-error' : ''}`} >Diagnóstico</label>
                <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
            </div>
        </>
    )

    const componentRender = () => {
        return (
            <>
                <div className="row mb-2">
                    {componentProps.autoGestion ? null :
                        <div className="col-md-3">
                            <AccountEditor label="Empleado" idAccount={formData.IDAccount} onChange={(e) => { setFormData({ ...formData, IDAccount: e.IDAccount }) }} />
                        </div>
                    }
                    <div className="col-md-2">
                        <AccountantYear idSelector={formData.Year} onChange={(e) => { setFormData({ ...formData, Year: e }) }} />
                    </div>
                    <div className="col-md-2">
                        <LiquidateMonthConstantsEditor label="Mes" idSelector={formData.Month} onChange={(e) => { setFormData({ ...formData, Month: e }) }} />
                    </div>
                    <div className="col-md-4">
                        <IncapacityStateConstants idSelector={formData.State} onChange={(e) => { setFormData({ ...formData, State: e }) }} />
                    </div>
                    <div className="col-3">
                        <IncapacityTypeConstantsEditor idSelector={formData.Type} onChange={(e) => { setFormData({ ...formData, Type: e }) }} label="Tipo de Incapacidad" />
                    </div>

                    <div className="col-2 d-flex">
                        <div className="row d-flex align-content-end">
                            <BasicButton useMargin icon="ri-search-line" eventClick={getLista} >Buscar</BasicButton>
                        </div>
                    </div>
                    {componentProps.autoGestion ? null :
                        <div className="col-md-6 mt-4 -p-2">
                            <BasicButton icon="ri-profile-line" clase="btn btn-outline-primary btn-border" eventClick={veraplicar}>
                                Aplicar Distribución de Pagos a Incapacidades
                            </BasicButton>
                        </div>
                    }
                </div>

                <BasicTable headButtons={buttons()} iconButtons={iconButtonsItem} listButtons={listaBotones()} head={head} body={lista} rowSet={setBean} records={paginador} />

                <Modal modal={modal} updateModal={setModal} eventModal={() => { validateData() }} >
                    <div className="row">
                        {commonFieds}
                        {!componentProps.autoGestion &&
                            <>
                                <div className="col-md-6">
                                    <label className={`${missingFields.includes('IDAccount') ? 'has-error' : ''}`} >Empleado</label>
                                    <AccountEditor label=" " idAccount={bean.IDAccount} onChange={(e) => { setBean({ ...bean, IDAccount: e.IDAccount }) }} />
                                </div>

                                <div className="col-md-6">
                                    <IncapacityStateConstants idSelector={bean.State} onChange={(e) => { setBean({ ...bean, "State": e }) }} />
                                </div>

                                <div className="col-md-6">
                                    <label >Numero de Radicación</label>
                                    <input type="text" className="form-control" name="FileNumber" value={bean.FileNumber} onChange={handleChange} />
                                </div>

                                <div className="col-md-6">
                                    <label>Fecha de Radicación</label>
                                    <InputDate label=" " name="FiledDate" value={bean.FiledDate} setDate={(e: any) => { setBean({ ...bean, 'FiledDate': e }) }} />
                                </div>

                                <div className="col-md-6">
                                    <label >Usuario que Radica</label>
                                    <AccountEditor label=" " idAccount={bean.IDFiledAccount} onChange={(e) => { setBean({ ...bean, "IDFiledAccount": e.IDAccount }) }} />
                                </div>

                                <div className="col-md-6">
                                    <AccountEditor label="A Cargo de" idAccount={bean.Third} onChange={(e) => { setBean({ ...bean, "Third": e.IDAccount }) }} />
                                </div>

                                <div className="col-md-6">
                                    <BasicSwitch label="Prorroga" estado={bean.Extending} eventChange={(e) => { setBean({ ...bean, "Extending": e }) }} />
                                </div>

                                <div className="col-md-6">
                                    <BasicSwitch label="Hospitalización" estado={bean.Hospitalization} eventChange={(e) => { setBean({ ...bean, "Hospitalization": e }) }} />
                                </div>

                                <div className="col-md-6">
                                    <BasicSwitch label="+90 Días" estado={bean.Days_90} eventChange={(e) => { setBean({ ...bean, "Days_90": e }) }} />
                                </div>

                                <div className="col-md-6">
                                    <BasicSwitch label="+180 Días" estado={bean.Days_180} eventChange={(e) => { setBean({ ...bean, "Days_180": e }) }} />
                                </div>

                                <div className="col-md-6">
                                    <BasicSwitch label="Aplicar Distribución de Pagos" estado={bean.ApplyPaymentDistribution} eventChange={(e) => { setBean({ ...bean, "ApplyPaymentDistribution": e }) }} />
                                </div>

                                <div className="col-md-6">
                                    <BasicSwitch label="Definir IBC" estado={bean.ApplyIBC} eventChange={(e) => { setBean({ ...bean, "ApplyIBC": e }) }} />
                                </div>

                                {bean.ApplyIBC &&
                                    <div className="col-md-6">
                                        <label >IBC a Aplicar</label>
                                        <input type="number" className="form-control" name="IbcToApply" value={bean.IbcToApply} onChange={handleChange} />
                                    </div>
                                }
                                <div className="col-md-6">
                                    <BasicSwitch label="Liquidar al 100% del Salario" estado={bean.LiquidateToTotalSalary} eventChange={(e) => { setBean({ ...bean, "LiquidateToTotalSalary": e }) }} />
                                </div>
                            </>
                        }
                    </div>
                </Modal>

                <Modal modal={modalconsultar} updateModal={setModalconsultar}>
                    <AppliedIncapacity idIncapacity={bean.IDIncapacity} />
                </Modal>

                <Modal modal={modalgenerar} updateModal={setModalgenerar} eventModal={updateMonthAppliedIncapacityDistribution}>
                    <div className="row">
                        <div className="col-md-6">
                            <label >Año a Aplicar</label>
                            <SelectElectronicPayrollIncapacitiesYears idSelector={customForm.Year} onChange={(e) => { setCustomForm({ ...customForm, "Year": e }) }} label=" " />
                        </div>

                        <div className="col-md-6">
                            <label >Mes inicial de pago</label>
                            <SelectElectronicPayrollIncapacitiesMonths year={customForm.Year} label=" " idSelector={customForm.InitialPaymentMonth} onChange={(e) => { setCustomForm({ ...customForm, "InitialPaymentMonth": e }) }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalaplicar} updateModal={setModalaplicar} eventModal={updatetEmployeeIncapacitiesDistribution}>
                    <div className="row">
                        <div className="col-md-6">
                            <AccountantYear idSelector={customForm.Year} onChange={(e) => { setCustomForm({ ...customForm, "Year": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <PayrollMonthsConstantsEditor label='Mes inicial de pago' idSelector={customForm.Month} onChange={(e) => { setCustomForm({ ...customForm, "Month": e }) }} />
                        </div>

                    </div>
                </Modal>

                <Modal modal={modalradicar} updateModal={setModalradicar} eventModal={fileEmployeeIncapacity}>
                    <div className="row">
                        <div className="col-md-12">
                            <label >Radicado</label>
                            <input type="number" className="form-control" name="FiledNumber" value={customForm.FiledNumber} onChange={(e) => {
                                const valor = e.target.value ? Number(e.target.value) : null
                                setCustomForm({ ...customForm, FiledNumber: valor })
                            }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalrechazar} updateModal={setModalrechazar} eventModal={rejectEmployeeIncapacity}>
                    <div className="row">
                        <div className="col-md-12">
                            <label >Observaciones</label>
                            <textarea className="form-control" name="Observations" value={customForm.Observations} onChange={(e) => { setCustomForm({ ...customForm, Observations: e.target.value }) }} />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar Incapacidad de {bean.AccountName}</strong>
                </ModalConfirm>

                <Modal modal={modalDownload.modal} updateModal={modalDownload.setModal}>
                    <div className="row">
                        <div className="col-md-12">
                            {listaAll.length > 0 &&
                                <ExportXLSL customName={'incapacidades'} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaAll} onExport={(name: string) => {
                                    _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                }} />
                            }
                        </div>
                    </div>
                </Modal>
            </>
        )
    }

    return isModal ? componentRender() :
        (
            <BasicPage titulo="Ingresar Incapacidades Laborales">
                {componentRender()}
            </BasicPage>
        )
}